import { render, staticRenderFns } from "./grey-warning-square.vue?vue&type=template&id=5d704b46&functional=true"
import script from "./grey-warning-square.vue?vue&type=script&lang=js"
export * from "./grey-warning-square.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports